// @ts-ignore
import { logger } from '../main';
import { useConversationStore } from "@/stores/conversation";
import CoreService from "@/services/core.service";
import Pusher from "pusher-js";
import { AuthorType } from "@/types/UserTypes";
let channel = null;
let conversationStore;
let pusherInstance = null;
let sessionId = null;
export default {
    getConversationStore() {
        if (!conversationStore) {
            conversationStore = useConversationStore();
        }
        return conversationStore;
    },
    init(sid) {
        sessionId = sid;
    },
    isConnected() {
        return channel !== null;
    },
    connect() {
        if (channel) {
            return;
        }
        // create pusher instance and export it so it can be used outside Vue components too
        pusherInstance = new Pusher('e95ed0097f768e54db91', { cluster: 'eu' });
        this._subscribe(sessionId);
        this._bind('default', (event) => {
            logger.debug('incoming websocket data:', event.name);
            switch (event.name) {
                case 'message.new':
                    event.conversations.forEach(conversation => {
                        conversation.items.forEach(msg => {
                            // support for propagating customer messages to other open tabs with same convo
                            // if author of new message is from the customer, check if message is already received.
                            if (msg.authorType === AuthorType.CUSTOMER) {
                                // timeout required as it takes time before the new message id is set.
                                // consider that sending outbound message to server takes longer, which will return the msgId.
                                // meanwhile the server sends back the same message to all subscribers, including the one that the message originates from.
                                // the newly obtained msgId could not receive in time and therefore the message will be added double.
                                //todo: If we have time, we should change the implementation so we check for the tempId and let server sends back this tempId.
                                // Then we can remove the setTimeout.
                                setTimeout(() => {
                                    if (!this.getConversationStore().getMessageById(conversation.id, msg.id)) {
                                        this.getConversationStore().addMessage(conversation.id, msg);
                                    }
                                }, 1000);
                            }
                            else {
                                this.getConversationStore().addMessage(conversation.id, msg);
                            }
                        });
                    });
                    break;
                case 'message.update':
                    event.conversations.forEach(conversation => {
                        conversation.items.forEach(item => {
                            this.getConversationStore().updateMessage(conversation.id, item);
                        });
                    });
                    break;
                case 'conversation.update':
                    this.getConversationStore().update(event.id, event.updated);
                    break;
                case 'conversation.close':
                    this.getConversationStore().close(event.id);
                    break;
                case 'agent.update':
                    if (event.agentsOnline)
                        CoreService.setAgentOnline(event.agentsOnline);
                    if (event.agents)
                        CoreService.updateAgents(event.agents);
                    break;
                default:
                    logger.error(`${event.name} not supported`);
                    break;
            }
        });
    },
    _subscribe(channelName) {
        // websocket setup
        channel = pusherInstance.subscribe(channelName);
        logger.debug('subscribe to pusher channel:', channelName);
        channel.bind('pusher:subscription_succeeded', () => {
            logger.debug('[websocket]', 'subscription succeeded');
        });
    },
    _bind(eventName, cb) {
        channel.bind(eventName, (event) => {
            cb(event);
        });
    },
};
